<template>
<div class="">
    <div class="text-center mt-5">
        <h5 class="text-center gray" style="line-height:1.5; margin-top:6rem">No provider available for this payment option. Kindly use other payment options</h5>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from './includes/bus.js';
/* eslint-disable */
export default {
    name: 'NoProvider',
    props: ['data', 'client_info'],

    computed: {
        item() {
            return this.data.details;
        }
    },
    mounted() {
        // console.log(this.data);

        EventBus.$on('global-back', payload => {
            // console.log(payload);
            if (payload.in_view.toLowerCase() == 'noprovider' && payload.action == "back") {
                this.changePaymentOption();
            }
        });
    },
    methods: {
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
        },
    },
}
</script>
